<template>
  <div>
    <div class="navbar" v-if="appPage === 'app-screen-splash'">
      <button @click="screenSplashNext" class="navigation" style="grid-column: 1/3;">{{ text['0002'] }}</button>
    </div>

    <div class="navbar" v-if="appPage === 'app-screen-laser-use'">
      <button @click="screenLaserUsePrevious" class="navigation secondary">{{ text['0009'] }}</button><button @click="screenLaserUseNext" class="navigation" :class="{disabled: !laserUseComplete}">{{ text['0012'] }}</button>
    </div>

    <div class="navbar" v-if="appPage === 'app-screen-category'">
      <button @click="screenCategoryPrevious" class="navigation secondary">{{ text['0009'] }}</button><button @click="screenCategoryNext" class="navigation" :class="{disabled: categorySelection === 0}">{{ text['0012'] }}</button>
    </div>

    <div class="navbar" v-if="appPage === 'app-screen-application'">
      <button @click="screenApplicationPrevious" class="navigation secondary">{{ text['0009'] }}</button><button @click="screenApplicationNext" class="navigation" :class="{disabled: categorySelection === 0}">{{ text['0012'] }}</button>
    </div>

    <div class="navbar navbar-result" v-if="appPage === 'app-screen-result'">
      <button @click="screenResultNew" class="navigation tertiary">{{ text['0021'] }}</button>
      <button @click="screenResultModify" class="navigation secondary">{{ text['0022'] }}</button>
      <button @click="screenEmail" class="navigation">{{ text['0023'] }}</button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { mapActions } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        currentLanguage: 'getLanguage',
        text: 'getText',
        appPage: 'navigation/getAppPage',
        laserUseComplete: 'laserUse/isCompleted',
        categorySelection: 'application/getCategorySelection',
      }),
    },
    methods: {
      ...mapActions({
        screenSplashNext: 'navigation/screenSplashNext',
        screenLaserUseNext: 'navigation/screenLaserUseNext',
        screenLaserUsePrevious: 'navigation/screenLaserUsePrevious',
        screenCategoryNext: 'navigation/screenCategoryNext',
        screenCategoryPrevious: 'navigation/screenCategoryPrevious',
        screenApplicationNext: 'navigation/screenApplicationNext',
        screenApplicationPrevious: 'navigation/screenApplicationPrevious',
        screenResultModify: 'navigation/screenResultModify',
        screenResultNew: 'navigation/screenResultNew',
        screenEmail: 'navigation/screenEmail',
      }),
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Navigation.vue